import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const DriverMedicalStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.koerekort.dl_medical).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  return (
    <StepContainer title="Har du en gyldig lægeattest?">
      {body && <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>}
      <fieldset>
        <div className="radio-group">
          <label>
            <input
              type="checkbox"
              name="dlHasMedicalDoc"
              checked={!!selfServiceData.dlHasMedicalDoc}
              onChange={(e) => updateSelfServiceData('dlHasMedicalDoc', e.target.checked)}
            />
            <span>Ja, jeg medbringer en gyldig lægeattest til borgerservice</span>
          </label>
        </div>
      </fieldset>
      <NavigationButtons onBack={goBack} onNext={goNext} nextDisabled={!selfServiceData.dlHasMedicalDoc} />
    </StepContainer>
  );
};

export default DriverMedicalStep;


